export const inboxForMeFlexPaneTitle = "$Aa";
export default {inboxForMeFlexPaneTitle};